import type { ReactNode } from 'react';
export type PillTone =
  'ok' | 'warn' | 'danger' | 'primary' | 'accent' | 'neutral' | 'qr';
const TONE: Record<PillTone, string> = {
  ok: 'bg-ok-light text-ok',
  warn: 'bg-warn-light text-warn',
  danger: 'bg-danger-light text-danger',
  primary: 'bg-primary-light text-primary',
  accent: 'bg-accent-light text-accent-dark',
  qr: 'bg-qr-light text-qr',
  neutral: 'bg-line-2 text-ink-2',
};
export function Pill({
  tone = 'neutral',
  children,
}: {
  tone?: PillTone;
  children: ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap px-2.5 py-0.5 rounded-chip text-sm-label font-semibold ${TONE[tone]}`}
    >
      {children}
    </span>
  );
}
